import { createSelector } from 'reselect';
export const selectFiltersState = createSelector((state) => state.filters, filters => filters);
export const selectFilters = createSelector(selectFiltersState, filters => filters.list);
